export default function StoreCredit() {
  return (
    <p className="store-footer__credit">
      Loja criada com <strong>AtomicPay</strong>
    </p>
  );
}
